import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-alert--sprite",
  "use": "calendar-alert--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\" id=\"calendar-alert--sprite\"><path d=\"M6 1v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2h-1V1h-2v2H8V1H6M5 8h14v11H5V7m6 2v5h2V9h-2m0 7v2h2v-2h-2z\" /><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" fill=\"rgba(0, 0, 0, 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol